const ACCOUNTS_API_URL = process.env.VUE_APP_ACCOUNTS_API_URL;
const PJILI_PLUS_UI_URL = process.env.VUE_APP_PJILI_PLUS_UI_URL;
const AUCTIONS_UI_URL = process.env.VUE_APP_AUCTIONS_UI_URL;
const AFTER_LOGIN_CONTINUE_ALLOWED_HOSTS = process.env.VUE_APP_AFTER_LOGIN_CONTINUE_ALLOWED_HOSTS;


export default {
  ACCOUNTS_API_URL,
  PJILI_PLUS_UI_URL,
  AUCTIONS_UI_URL,
  AFTER_LOGIN_CONTINUE_ALLOWED_HOSTS
}